import {
    ApiShopperLandingPage,
    ApiShopperLandingPageLink,
    VLPVariant,
} from '@storefronts/common-types'
import Script from 'next/script'
import { VariantWithImage } from '../../types'
import { markVendorReady, runWhenReady } from './pixelRuntime'

export const PostscriptPixel: React.FC<{
    landingPage: ApiShopperLandingPage
}> = ({ landingPage }) => {
    if (!landingPage.integrations.postscriptId) return null

    return (
        <Script
            id="postscript"
            async
            strategy="afterInteractive"
            src={`https://sdk.postscript.io/sdk.bundle.js?shopId=${landingPage.integrations.postscriptId}`}
            onReady={() => markVendorReady('postscript')}
        ></Script>
    )
}

export class PostscriptTracker {
    public static shopId: string | null = null

    static initialize(shopId: string) {
        PostscriptTracker.shopId = shopId
    }

    static checkPostscript(): boolean {
        return window.hasOwnProperty('postscript')
    }

    static trackProductView(
        link: ApiShopperLandingPageLink,
        variant: VLPVariant,
    ) {
        runWhenReady('postscript', () => {
            if (!PostscriptTracker.checkPostscript()) return

            window.postscript.event('page_view', {
                shop_id: PostscriptTracker.shopId,
                url: window.location.href,
                page_type: 'product',
                resource: {
                    category: null,
                    name: link.title,
                    price_in_cents: variant.price.price,
                    resource_id: link.shopifyId,
                    resource_type: 'product',
                    sku: null,
                    variant_id: variant.shopifyId,
                    vendor: null,
                },
            })
        })
    }

    static trackAddToCart(variant: VariantWithImage, _cartId: string) {
        runWhenReady('postscript', () => {
            if (!PostscriptTracker.checkPostscript()) return

            window.postscript.event('add_to_cart', {
                shop_id: PostscriptTracker.shopId,
                url: window.location.href,
                page_type: 'product',
                resource: {
                    category: null,
                    name: variant.title,
                    price_in_cents: variant.price.price,
                    resource_id: variant.shopifyId,
                    resource_type: 'product',
                    sku: null,
                    variant_id: variant.shopifyId,
                    vendor: null,
                },
            })
        })
    }
}
